import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { useCreatedRecordTitleAssignment } from 'automation-ui-action-features/actions/create-object/utils/useCreatedRecordTitleAssignment';
import CreateObjectTitleLabel from 'automation-ui-action-features/actions/create-object/CreateObjectTitleLabel';
import CreateObjectOwnerLabel from 'automation-ui-action-features/actions/create-object/CreateObjectOwnerLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateObjectActionExplainer({
  action,
  flowObjectTypeId
}) {
  const metadata = action.metadata;
  const objectTypeId = metadata.objectTypeId;
  const {
    value: titlePropertyAssignment,
    propertyDefinition
  } = useCreatedRecordTitleAssignment(metadata);
  if (!flowObjectTypeId) {
    return null;
  }
  const title = /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(CreateObjectTitleLabel, {
      flowObjectTypeId: flowObjectTypeId,
      propertyAssignment: titlePropertyAssignment,
      omitQuotes: true,
      propertyDefinition: propertyDefinition
    })
  });
  const owner = /*#__PURE__*/_jsx(CreateObjectOwnerLabel, {
    metadata: metadata,
    flowObjectTypeId: flowObjectTypeId
  });
  return /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
    baseLangKey: "automation-ui-action-features.action-features.create-object.explainer_cob",
    objectTypeId: objectTypeId,
    options: {
      title,
      owner
    }
  });
}